$(document).ready(function() {
    $('#project-gallery-wrapper').lightGallery({
        selector: '.light-link',
        fullScreen: true
    });

    $('.btn-view-more').click(function() {
        $(this).hide();
        $('.more-images').collapse('show');
        document.querySelectorAll('.project-gallery.d-none').forEach(e => {
            e.classList.remove('d-none');
        })
    });
});